<template>
  <div>
    <form @submit.prevent="validarCamposMat" class="xcard" style="margin-top:0;" novalidate>
      <div v-if="matri">
        <p> <b>Monto matricula:</b> {{matri.monto}} Bs. </p>
        <p> <b>Saldo:</b> {{matri.saldo}} Bs.</p>
      </div>
      
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.idmatricula')}">
            <input type="text" v-model.trim="matricula.idmatricula" class="form-control" placeholder="Id de la matricula" :disabled="true"/>
            <small>ID</small>
            <div class="error" v-if="validation.hasError('matricula.idmatricula')"> {{validation.firstError('matricula.idmatricula')}} </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.monto')}">
            <input type="text" v-model.trim="matricula.monto" class="form-control" placeholder="Monto a cancelar" />
            <small>Monto en Bs.</small>
            <div class="error" v-if="validation.hasError('matricula.monto')"> {{validation.firstError('matricula.monto')}} </div>
          </div>
        </div>

        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.tipo_pago')}">
            <select v-model="matricula.tipo_pago" class="form-control form-control-sm">
              <option value="true">Credito</option>
              <option value="false">Contado</option>
            </select>
            <small>Tipo de pago</small>
            <div class="error" v-if="validation.hasError('matricula.tipo_pago')"> {{validation.firstError('matricula.tipo_pago')}} </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.monto')}">
            <Fecha :model="matricula" :valueto="'fecha_pago'"/>
            <small>Fecha de pago</small>
            <div class="error" v-if="validation.hasError('matricula.monto')"> {{validation.firstError('matricula.monto')}} </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.nro_recibo')}">
            <input type="text" v-model.trim="matricula.nro_recibo" class="form-control" placeholder="Numero del recibo" />
            <small>Nro. Recibo</small>
            <div class="error" v-if="validation.hasError('matricula.nro_recibo')"> {{validation.firstError('matricula.nro_recibo')}} </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group form-group-sm" :class="{'has-error': validation.hasError('matricula.descripcion')}">
            <input type="text" v-model.trim="matricula.descripcion" class="form-control" placeholder="Observaciones" />
            <small>Observacion</small>
            <div class="error" v-if="validation.hasError('matricula.descripcion')"> {{validation.firstError('matricula.descripcion')}} </div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <p class="text-center">{{msg}}</p>
      <notifications group="auth" position="bottom right" />
      <button v-show="activo" class="btn btn-azul center-block" @click="validarCamposMat"> Registrar pago de matricula </button>
    </form>
  </div>
</template>

<script>
import { Validator } from 'simple-vue-validator'
import Fecha from '@/components/AFecha.vue'
import Alertas from '@/components/AAlertas.vue'
import {error,parseJsonError} from '@/components/Utils.js'
import gql from 'graphql-tag'

export default {
  props:{
    id:{type:Number,required:true},
    matri:{type:Object,required:false},
    listener:{type:Object,required:true}
  },
  data() {
    return {
      msg: '',
      activo: true,
      matricula:{
        idmatricula: null,
        monto: null,
        tipo_pago: true,
        fecha_pago: null,
        nro_recibo: null,

        descripcion: null
      }
    };
  },
  components:{Fecha,Alertas},
  watch:{
    id:function(){ this.matricula.idmatricula = this.id },
    matricula:{
      deep: true,
      handler(){ 
        this.$refs.alertar.reset(); 
        window.sessionStorage.setItem("xmatricula", JSON.stringify(this.matricula) );
      }
    }
  },
  validators: {
    'matricula.idmatricula'(value){ return Validator.value(value).required(); },
    'matricula.monto'(value){ return Validator.value(value).required().digit(); },
    'matricula.fecha_pago'(value){ return Validator.value(value).required(); },
    'matricula.nro_recibo'(value){ return Validator.value(value).minLength(5).required(); },
  },
  methods:{
    validarCamposMat(){
      if( !this.activo ) return;
      this.activo = false;
      this.$validate().then((success) => {
        var obj = window.Object.assign({},this.matricula);
        if( success ){
          if( this.matricula.fecha_pago == "" ){
            this.$refs.alertar.invalido();
            this.$notify( error( 'Fecha','Falta la fecha del pago de matricula' ) );
            this.activo = true;
          }else{
            obj.monto = parseInt( obj.monto );
            obj.tipo_pago = obj.tipo_pago=="true"? true:false;
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');
            this.$refs.alertar.cargando();
            this.enviarDatos( obj )
          }
        }else{
          this.$refs.alertar.invalido();
          this.activo = true;
        }
      });
    },
    enviarDatos( obj ) {
      var mon = obj.monto;
      var vue = this;
      var sql = gql`mutation{ realizarPagoMatricula(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
      vue.msg = "Registrando...";
      // window.console.log(sql);

      this.$apollo.mutate({
        mutation: sql
        }).then(data => {
          if (data.data.realizarPagoMatricula.ok) {
            vue.$refs.alertar.success();
            window.sessionStorage.setItem("xmatricula", null);
            //this.activo = true;
            vue.msg = "";
            if( vue.matri ){
              vue.matri.saldo -= mon;
            }
            this.listener.flag = new Date().getTime();
            setTimeout(function(){  vue.activo = true; },7000)
            //setTimeout(function(){ window.location.reload(); },400)
          } else {
            var errores = JSON.stringify(data.data.realizarPagoMatricula.errors);
            var obj = JSON.parse(errores);
            var vals = "Error Desconocido";
            if( obj != null ) obj.forEach(function(k) { vals += Object.values(k) + "-\n\t"; });
            vue.msg = vals;
            vue.activo = true;
            vue.$refs.alertar.invalido();
          }

          // window.console.log(data);
        }).catch(error => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(JSON.stringify(error));
          vue.msg = error;

          this.$notify(parseJsonError(error));
        });
    }
  },
  mounted(){
    this.matricula.idmatricula = this.id;
  }
};
</script>